module.exports = __webpack_public_path__ + "static/media/who-logo.68cee32f.png";